import BaseListStore from './BaseListStore'

export default BaseListStore
